export const SECTIONS = [
  ["dashboard", "Dashboard"],
  ["enquiries", "Enquiries"],
  ["customers", "Customers"],
  ["bookings", "Bookings"],
  ["orders", "Orders"],
  ["prep-sheet", "Prep Sheet"],
  ["routes", "Routes"],
  ["venues", "Venues"],
  ["menus", "Menus"],
  ["staffing", "Staffing"],
  ["equipment", "Equipment"],
  ["tasks", "Tasks"],
  ["reports", "Reports"],
  ["toolkit", "F&B Toolkit"],
  ["companies", "Companies"],
  ["hub-settings", "Hub Settings"],
];

const ALIASES = { fleet: "companies", providers: "companies" };

export const canSee = (user, to) => {
  if (!user) return false;
  if (user.platform_role === "super_admin" || user.impersonating || user.role === "admin") return true;
  const perms = user.permissions;
  if (perms == null) return true;
  let section = to.replace(/^\//, "").split("/")[0];
  section = ALIASES[section] || section;
  return perms.includes(section);
};
